import { Table } from "react-bootstrap";

const TableList = ({ children }: { children: any }) => {
    return <Table striped hover size="sm">
        <thead>
            <tr>
                <th>Slug</th>
                <th>Title</th>
                <th>Status</th>
                <th>Last Edited</th>
                <th className="text-center">Delete</th>
                <th className="text-center">Preview</th>
                <th className="text-center">Edit</th>
            </tr>
        </thead>
        {children}
    </Table>;
}
export default TableList;